/* eslint-disable @typescript-eslint/no-explicit-any */
import empty from "@assets/addFile.svg";
import { textVariants } from "../Text/Text";
import { cn } from "@/lib/utils";
interface Props {
  image?: string;
  message?: string;
  description?: string;
  button?: any;
}
const EmptyPage = ({ image, message, description, button }: Props) => {
  return (
    <div className="max-w-screen-xl mx-auto h-[80vh] md:px-4 p-2 flex items-center justify-center ">
      <div className="flex flex-col items-center justify-center">
        <img src={image ?? empty} alt="no data" className="h-52 " />
        <p
          className={cn(
            textVariants({ size: "xxl", font: "semibold" }),
            "mt-3"
          )}
        >
          {message}
        </p>
        <p className={textVariants({ variant: "desc", size: "lg" })}>
          {description ?? "No results found"}
        </p>
        <div className="mt-5">{button}</div>
      </div>
    </div>
  );
};

export default EmptyPage;
